export enum Steps {
  Dataset,
  Aggregation,
  Metrics,
  OptionsAndPreview,
}
